import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { StanCard } from '@/components';
import { useGlobalStore } from '@/stores';
import { CourseMetricsSection } from '@/features/analytics/components/courses/CourseMetricsSection';
import { CourseUsersTable } from '@/features/analytics/components/courses/CourseUsersTable';
import { useCourseAnalytics } from '@/queries/useCourses';
import { useStanRouter } from '@/hooks/useStanRouter';

export default function CourseAnalyticsPage() {
    const { courseId = '-1' } = useParams<{ courseId: string }>();
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);
    const { push } = useStanRouter();
    // Fetch course analytics
    const { data: analytics, error } = useCourseAnalytics(courseId);

    useEffect(() => {
        if (!error) {
            const breadcrumbs = [];

            if (analytics?.store_type === 'funnel') {
                breadcrumbs.push({
                    title: 'Funnel',
                    to: `/funnel/${analytics?.store_id}`,
                    id: 'funnel',
                });
            } else {
                breadcrumbs.push({
                    title: 'My Store',
                    to: '/linksites',
                    id: 'linksites',
                });
            }

            breadcrumbs.push({ title: 'Course Analytics', to: '', active: true, id: 'course-analytics' });
            setBreadcrumbs(breadcrumbs);
        } else {
            push('/stores');
        }
    }, [analytics, setBreadcrumbs, push, error]);

    if (!analytics) {
        return (
            <div className='flex h-96 items-center justify-center'>
                <p className='text-gray text-label-sm-regular'>Course not found</p>
            </div>
        );
    }

    return (
        <div className='flex w-full flex-col gap-6'>
            <StanCard>
                <div className='flex flex-col gap-2'>
                    <h2 className='text-dark text-title-display-3 md:text-title-display-2 mb-2 break-words'>
                        {analytics.course_name}
                    </h2>
                    <span className='text-gray text-label-sm-regular'>
                        {analytics.modules_count} Modules · {analytics.lessons_count} Lessons
                    </span>
                </div>
            </StanCard>

            <CourseMetricsSection analytics={analytics} />
            <CourseUsersTable courseId={courseId} analytics={analytics} />
        </div>
    );
}
